import React, { createContext, useCallback, useEffect, useState } from 'react';
import { useLocation } from 'react-router';
import { firestore } from './FirebaseContext';
import { rolesName } from '../constants/roles';

export const UserLockerContext = createContext({ currentLockerUser: {}, lockerId: '', verifyUserNip: () => {} });

function UserLockerProvider({ children }) {
  //   const { user, isAuthenticated } = useAuth();
  const [currentLockerUser, setCurrentLockerUser] = useState(null);
  const [currentLockerId, setCurrentLockerId] = useState(null);
  // console.log('usuario', currentUser);
  const { pathname } = useLocation();
  const arrUbication = pathname.split('/')[1];

  // console.log(currentLockerUser, currentLockerId, '===================DddDD============');
  // console.log({ currentLockerUser });

  const { search } = useLocation();
  const queryParams = new URLSearchParams(search);
  //   const lockerId = queryParams.get('lockerId');
  // const lockerId = currentLockerId || 'testlocker';
  const lockerId = currentLockerId;

  useEffect(() => {
    const userLocker = localStorage.getItem('userLocker');
    if (userLocker) {
      setCurrentLockerUser(JSON.parse(userLocker));
      setCurrentLockerId(JSON.parse(userLocker).lockerACargo);
    }
  }, []);

  const getUserLockerData = useCallback(async (userId) => {
    try {
      await firestore
        .collection('users')
        .doc(userId)
        .onSnapshot((doc) => {
          // console.log(doc.data(), 'dentro de la funcion');
          const userLocker = { id: doc.id, ...doc.data() };
          if (userLocker?.role === rolesName.locker) {
            setCurrentLockerUser(userLocker);
            setCurrentLockerId(doc.data().lockerACargo);

            localStorage.setItem('userLocker', JSON.stringify({ id: doc.id, ...doc.data() }));
          }
        });
    } catch (error) {
      return false;
    }
  }, []);
  // const getUserLockerData = useCallback(async () => {
  //   await firestore
  //     .collection('users')
  //     .where('lockerACargo', '==', lockerId)
  //     .onSnapshot((query) => {
  //       const data = query.docs.map((doc) => ({ id: doc.id, ...doc.data() }))[0];
  //       setCurrentLockerUser(data);
  //       setCurrentLockerId(data?.lockerACargo ? data?.lockerACargo : null);
  //     });
  // }, [lockerId]);

  // useEffect(() => {
  //   // console.log('se renderiza');
  //   // async function getUserInfo() {
  //   //   await firestore
  //   //     .collection('users')
  //   //     .where('lockerACargo', '==', lockerId)
  //   //     .onSnapshot((query) => {
  //   //       const data = query.docs.map((doc) => ({ id: doc.id, ...doc.data() }))[0];
  //   //       setCurrentLockerUser(data);
  //   //       setCurrentLockerId(data?.lockerACargo ? data?.lockerACargo : null);
  //   //     });
  //   // }

  //   if (lockerId && arrUbication === 'locker') {
  //     // getUserInfo();
  //     getUserLockerData();
  //   }
  // }, [arrUbication, getUserLockerData, lockerId]);

  const verifyUserNip = useCallback(
    (userNip) => {
      if (currentLockerUser?.nip === userNip) {
        return true;
      }
      return false;
    },
    [currentLockerUser]
  );

  return (
    <UserLockerContext.Provider value={{ currentLockerUser, lockerId, verifyUserNip, getUserLockerData }}>
      {children}
    </UserLockerContext.Provider>
  );
}

export default UserLockerProvider;
